export default "__VITE_ASSET__DdK153Q3__"